// Learn TypeScript:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/typescript.html
// Learn Attribute:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/reference/attributes.html
// Learn life-cycle callbacks:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/life-cycle-callbacks.html

import BasePopUpLayer from "../../../../../engines/components/BasePopUpLayer";
import utilsModel from "../../../../../engines/libs/utilsModel";
import utilsView from "../../../../../engines/libs/utilsView";
import CsvDataManage from "../../../../../engines/managers/CsvDataManage";
import { CsvFileKind } from "../../../../define/CsvFileKind";
import { FileKind } from "../../../../define/FileKind";
import { GeneralKind } from "../../../../define/GeneralKind";
import { SettleLawsuitKind } from "../../../../define/SettleLawsuitKind";
import { backPackEventMap } from "../../../config/BackpackEventConfig";
import NormalGameManager from "../../../manager/NormalGameManager";
import SettleLawsuitLayer from "../common/SettleLawsuitLayer";
import SettleLawsuitPrimaryPeopleNode from "./SettleLawsuitPrimaryPeopleNode";
import SettleLawsuitPrimarySelect from "./SettleLawsuitPrimarySelect";

const {ccclass, property} = cc._decorator;

/** 自己说话背景和文字位置差 */
// const c_selfTalkSpaceY = 76;
@ccclass
export default class SettleLawsuitPrimaryLayer extends SettleLawsuitLayer {

    @property({ type: cc.Node, displayName:'' })
    sprJudge: cc.Node = null;

	@property({ type: sp.Skeleton, displayName:'' })
	spineJudge: sp.Skeleton = null;

	@property({ type: cc.Node, displayName:'' })
	btnJudgeSelect: cc.Node = null;

	@property({ type: cc.Node, displayName:'' })
	btnJudgment: cc.Node = null;

	@property({ type: cc.Node, displayName:'' })
	btnStart: cc.Node = null;

	@property({ type: cc.Node, displayName:'' })
	nodeStartHint: cc.Node = null;

	@property({ type: cc.Label, displayName:'' })
	labelTalkSelf: cc.Label = null;

	@property({ type: cc.Node, displayName:'' })
	nodeTalkSelf: cc.Node = null;

    @property({ type: cc.Node, displayName:'' })
	nodePeopleList: cc.Node = null;

    @property(cc.Prefab)
    prefabPeople: cc.Prefab = null;

	@property({ type: cc.Node, displayName:'' })
	sprVideo: cc.Node = null;

	@property({ type: cc.Label, displayName:'' })
	labelPropNum: cc.Label = null;

	@property({ type: cc.Label, displayName:'' })
	labelPropName: cc.Label = null;

	@property({ type: cc.Node, displayName:'' })
	sprPropBg: cc.Node = null;

	@property({ type: cc.Button, displayName:'' })
	btn_prop: cc.Button = null;
    
    @property(cc.Prefab)
    prefabSelect: cc.Prefab = null;
    @property(cc.Prefab)
    prefabStepSelect: cc.Prefab = null;

    @property({ type: cc.Node, displayName:'' })
	sprTalkBg: cc.Node = null;

    // @property(cc.Prefab)
    // prefabSelectSpecial: cc.Prefab = null;

    /** 人物id组 */
    private peopleArr: string[] = [];
    private csvInfo: any = null;
    private propNum = 0;

    private peopleScriptArr: SettleLawsuitPrimaryPeopleNode[] = [];
    /** 已经查看的证物列表 */
    private lookExhibitList: string[] = [];
    /**  */
    private selectLayer: SettleLawsuitPrimarySelect = null;
    /**  */
    private chargeSelectArr: string[] = []
    private exhibitArr: string[] = []
     /** 最小高度 */
    //  private minTalkHeight = 0;

    private maxTalkWidth = 0;
    private talkSpaceX = 0;
    private talkSpaceY = 0;

    // private curTalkIdx: number = 0;

    start () {
        // this.minTalkHeight = this.sprTalkBg.height;

        this.maxTalkWidth = this.labelTalkSelf.node.width;
        this.talkSpaceX = this.sprTalkBg.width - this.labelTalkSelf.node.width;
        this.talkSpaceY = this.sprTalkBg.height - this.labelTalkSelf.node.height;

        this.initLayer();
    }

    initLayer() {
        let id = this._carryData.id;
        this.csvInfo = CsvDataManage.instance.getCsvDataItem(CsvFileKind.CsvFile.LEGAL_CASE_PRIMARY, id);
        if (!this.csvInfo) {
            console.error(`数据获取失败`);
            return;
        }
        this.initPeopleArr();
        // this.initPropInfo();
        this.resetData();
    }

    resetData() {
        
        this.lookExhibitList = [];
        this.chargeSelectArr = [];
        this.exhibitArr = [];

        this.spineJudge.node.active = false;
        this.btnJudgeSelect.active = false;
        this.btnJudgment.active = false;
        this.btnStart.active = false;
        this.sprJudge.active = false;

        this.nodeStartHint.active = false;
        this.nodeTalkSelf.active = false;

        if (this.selectLayer) {
            this.selectLayer.destroyNode();
            this.selectLayer = null;
        }

        // this.curTalkIdx = 0;
        cc.tween(this.node)
        .delay(1)
        .call(()=> {
            this.startFirstStep();
        })
        .start();
    }

    initPeopleArr() {
        let people: string = this.csvInfo.people;
        let splits = utilsModel.splitLineFeed(people);
        // for (let i = 0; i < splits.length; i++) {
        //     let peopleId = CsvDataManage.instance.getPeopleArrayRandomId(splits[i]);
        //     if (!peopleId) {
        //         console.error(`人物获取错误`);
        //         continue;
        //     }
        //     if (this.peopleArr.includes(peopleId)) {
        //         i--;
        //         continue;
        //     }
        //     this.peopleArr.push(peopleId);
        // }
        this.peopleArr = splits;
        this.initPeopleUI();
    }

    initPeopleUI() {
        for (let i = 0; i < this.peopleArr.length; i++) {
            let o = this.peopleArr[i];
            let nodePeople = cc.instantiate(this.prefabPeople);
            let peopleScript = nodePeople.getComponent(SettleLawsuitPrimaryPeopleNode);
            peopleScript.setCarryData({
                id: o
                , parent: this
                , idx: i
            });
            this.nodePeopleList.addChild(nodePeople);
            this.peopleScriptArr.push(peopleScript);
        }
    }

    startFirstStep() {
        // this.nodeStartHint.x = -500;
        this.nodeStartHint.active = true;
        let sprPeople1 = this.nodeStartHint.getChildByName('sprPeople1');
        let sprHintDialog = this.nodeStartHint.getChildByName('sprHintDialog');
        sprPeople1.angle = 0;
        sprHintDialog.active = false;
        cc.tween(sprPeople1)
        .to(0.25, {angle: -45})
        .call(()=> {
            sprHintDialog.active = true;
        })
        .delay(2)
        .call(()=> {
            sprHintDialog.active = false;
            this.btnStart.active = true;
            this.sprJudge.active = false;
        })
        .to(0.25, {angle: 0})
        .call(()=> {
            this.nodeStartHint.active = false;
        })
        .start();
    }

    openSelectLayer() {
        this.btnJudgeSelect.active = true;
        this.btnJudgment.active = false;

        if (this.selectLayer) {
            this.selectLayer.showUI(true);
            return;
        }

        let node = cc.instantiate(this.prefabSelect);
        let script = node.getComponent(SettleLawsuitPrimarySelect);
        script.setCarryData({
            parent: this
            , csvInfo: this.csvInfo
            , peopleArr: this.peopleArr
            , lookExhibitList: this.lookExhibitList
        });
        this.node.addChild(node);
        this.selectLayer = script;
    }
    
    initPropInfo() {
        let goodsId = GeneralKind.PropId.ASTRONOMER_MIRROR_ID;
        let itemConfig = backPackEventMap()[goodsId];
        this.labelPropName.string = itemConfig.name;
        
        this.refreshPropCount();
    }

    refreshPropCount() {
        let goodsId = GeneralKind.PropId.ASTRONOMER_MIRROR_ID;
        let propData = NormalGameManager._instance.getGameData().backpack[goodsId];
        let num = this.propNum = propData && propData.num || 0;
        this.labelPropNum.string = '×' + num;

        this.setPropState(num > 0);
    }

    setPropState(bEnable: boolean) {
        this.sprVideo.active = !bEnable;
        this.sprPropBg.color = bEnable ? cc.Color.WHITE : new cc.Color(0x87, 0x87, 0x87);
        this.btn_prop.node.color = bEnable ? cc.Color.WHITE : new cc.Color(0x87, 0x87, 0x87);
        this.labelPropNum.node.color = bEnable 
            ?  new cc.Color(0xFF, 0xFF, 0xF2) 
            :  new cc.Color(0xCD, 0x5C, 0x54);
    }

    anewStartSelect() {
        this.openSelectLayer();
    }

    async startTalkAni(dialogue: string, action: string) {
        let processSplits = utilsModel.splitLineFeed(dialogue);
        let actionSplits: string[] = [];
        if (utilsModel.isValidNumberValue(action)) {
            actionSplits = utilsModel.splitLineFeed(action);
        }
        for (let i = 0; i < processSplits.length; i++) {
            let o = processSplits[i];
            let talkArr = o.split(FileKind.ResParseType.SUB_ITEM);
            let talkIdx = Number(talkArr[0])-1;

            if (actionSplits[i] && actionSplits[i] != SettleLawsuitKind.PrimaryStepType.NONE) {
                let itemSplits = actionSplits[i].split(FileKind.ResParseType.ITEM);
                for (let ot of itemSplits) {
                    let oSplits = ot.split(FileKind.ResParseType.SUB_ITEM);
                    let pidx = oSplits[1] ? (Number(oSplits[1])-1) : talkIdx;
                    this.peopleScriptArr[pidx].playPeopleAni(oSplits[0], false, true);
                }
            }
            await this.peopleScriptArr[talkIdx].showTalkAni(talkArr[1]);
            if (!this.node || !cc.isValid(this.node)) {
                return;
            }
        }

        // this.curTalkIdx ++;
        // this.openSelectLayer();
    }

    showResultUI(bSuccess: boolean, retArr: string[]) {
        if (bSuccess) {
            this.openSuccessLayer(retArr, FileKind.PrefabFilePath.SettleLawsuitPrimarySuccessLayer);
        } else {
            this.openLoseLayer(retArr, FileKind.PrefabFilePath.SettleLawsuitPrimaryLoseLayer);
        }
    }

    showHighOfficaialLayer(
        bSuccess: boolean
        , retArr: string[]
        , loseArr: string[]
        , peopleIdx: number
        , selectArr: string[]
    ) {
        // let peopleId = this.peopleArr[peopleIdx];
        // let node = cc.instantiate(this.prefabSelectSpecial);
        // let script = node.getComponent(BasePopUpLayer);
        // script.setCarryData({
        //     parent: this
        //     , csvInfo: this.csvInfo
        //     , bSuccess: bSuccess
        //     , retArr: retArr
        //     , loseArr: loseArr
        //     , peopleId: peopleId
        //     , selectArr: selectArr
        // });
        // this.node.addChild(node);
    }

    async actionStep(stepId: string) {
        let csvSteps = CsvDataManage.instance.getCsvData(CsvFileKind.CsvFile.LEGAL_CASE_PRIMARY_STEP);
        if (!csvSteps) {
            console.error(`未找到表格`);
            return;
        }
        let title = csvSteps.title;
        let info = csvSteps[stepId];
        if (!info) {
            console.error(`未找到数据`);
            return;
        }
        let dialogue = info[title.dialogue];
        let action = info[title.action];
        if (utilsModel.isValidNumberValue(dialogue)) {
            await this.startTalkAni(dialogue, action);
            if (!this.node || !cc.isValid(this.node)) {
                return;
            }
        }

        let select = info[title.select];
        let is_show_btn = info[title.is_show_btn];
        let petitioner = Number(info[title.petitioner])-1;
        let exhibit = info[title.exhibit].trim();
        let relevancy_id = info[title.relevancy_id];

        let peopleNode = this.peopleScriptArr[petitioner];
        let node = cc.instantiate(this.prefabStepSelect);
        let script = node.getComponent(BasePopUpLayer);
        script.setCarryData({
            parent: this
            , select: select
            , petitioner: petitioner
            , peoplePos: peopleNode && peopleNode.node.convertToWorldSpaceAR(cc.v2())
            , exhibit: exhibit
            , relevancy_id: relevancy_id
            , is_show_btn: is_show_btn
            , lookExhibitList: this.lookExhibitList
        });
        
        this.node.addChild(node);

        if (utilsModel.isValidNumberValue(exhibit)) {
            let exhibitArr = utilsModel.splitLineFeed(exhibit);
            for (let o of exhibitArr) {
                if (this.lookExhibitList.includes(o)) {
                    continue;
                }
                this.lookExhibitList.push(o);
            }
            // this.lookExhibitList = this.lookExhibitList.concat(exhibitArr);
        }
    }

    nextStep(id: string) {
        if (id == SettleLawsuitKind.PrimaryStepType.END) {
            this.openSelectLayer();
        } else {
            this.actionStep(id);
        }
    }

    showJudgementUI(selectArr: string[], exhibitArr: string[]) {
        this.sprJudge.active = false;
        this.btnJudgment.active = true;
        
        this.chargeSelectArr = selectArr;
        this.exhibitArr = exhibitArr;
    }

    playJuegeAni(callback: Function) {
        this.spineJudge.node.active = true;
        this.spineJudge.setAnimation(0, 'animation', false);
        this.spineJudge.setCompleteListener(()=> {
            if (callback) {
                callback();
            }
            this.sprJudge.active = true;
            this.spineJudge.node.active = false;
        });
    }

    onClickStart() {
        this.btnStart.active = false;
        this.playJuegeAni(()=> {
            this.actionStep(this.csvInfo.start_step);
        });
        
    }

    onClickProp() {
        
    }

    onClickJudgeSelect() {
        this.openSelectLayer();
    }

    onClickJudgement() {
        this.btnJudgment.active = false;
        this.btnJudgeSelect.active = false;
        this.playJuegeAni(()=> {
            this.startEndAction();
        });
    }

    async showSelfTalk(strTalk: string) {
        let self = this;
        cc.Tween.stopAllByTarget(this.sprTalkBg);

        if (utilsModel.isValidNumberValue(strTalk)) {
            this.nodeTalkSelf.active = true;
            this.labelTalkSelf.overflow = cc.Label.Overflow.NONE;
            this.labelTalkSelf.string = strTalk;
            utilsView.refreshLabelUI(this.labelTalkSelf);
            if (this.labelTalkSelf.node.width > this.maxTalkWidth) {
                this.labelTalkSelf.overflow = cc.Label.Overflow.RESIZE_HEIGHT;
                this.labelTalkSelf.node.width = this.maxTalkWidth;
                utilsView.refreshLabelUI(this.labelTalkSelf);
            } else {
                this.labelTalkSelf.node.anchorX = 0.5;
                this.labelTalkSelf.node.x = 0;
            }
            this.sprTalkBg.width = this.labelTalkSelf.node.width + this.talkSpaceX;
            this.sprTalkBg.height = this.labelTalkSelf.node.height + this.talkSpaceY;
            this.labelTalkSelf.node.getComponent(cc.Widget).updateAlignment();
        }
        
        const time = 0.25;
        this.sprTalkBg.opacity = 0;
        return new Promise<void> ((resolve)=> {
            cc.tween(self.sprTalkBg)
            .to(time, {opacity: 255})
            .delay(2.5)
            .to(time, {opacity: 0})
            .call(()=> {
                resolve();
            })
            .start();
        });
    }

    async startEndAction() {
        let end_action = this.csvInfo.end_action;
        let actionArr = utilsModel.splitLineFeed(end_action);
        let csvActions = CsvDataManage.instance.getCsvData(CsvFileKind.CsvFile.LEGAL_CASE_PRIMARY_ACTION);
        if (!csvActions) {
            console.error('未找到表格');
            return;
        }

        let title = csvActions.title;
        for (let o of actionArr) {
            let info = csvActions[o];
            if (!info) {
                console.error(`未找到数据`);
                return;
            }
            let person = info[title.person];
            let dialogue = info[title.dialogue];
            let action = info[title.action];
            if (person == SettleLawsuitKind.PrimaryStepType.ME) {
                await this.showSelfTalk(dialogue);
                if (!this.node || !cc.isValid(this.node)) {
                    return;
                }
                this.nodeTalkSelf.active = false;
                continue;
            }
            let talkIdx = Number(person)-1;
            if (utilsModel.isValidNumberValue(action)) {
                this.peopleScriptArr[talkIdx].playPeopleAni(action, false, false);
            }
            await this.peopleScriptArr[talkIdx].showTalkAni(dialogue);
            if (!this.node || !cc.isValid(this.node)) {
                return;
            }
        }
        this.calcResult();
    }

    calcResult() {
        let correct_select = this.csvInfo.correct_select;
        let correct_exhibit = this.csvInfo.correct_exhibit;
        let exbihitList = utilsModel.splitLineFeed(correct_exhibit);
        let selectList = utilsModel.splitLineFeed(correct_select);
        let bSuccess = true;
        for (let o of exbihitList) {
            if (o.trim() == '') {
                continue;
            }
            let idx = this.exhibitArr.indexOf(o);
            if (idx == -1) {
                bSuccess = false;
                break;
            }
            this.exhibitArr.splice(idx, 1);
        }
        if (bSuccess && this.exhibitArr.length > 0) {
            bSuccess = false;
        }
        if (bSuccess) {
            for (let i = 0; i < selectList.length; i++) {
                let o = selectList[i];
                if (o.trim() == '') {
                    continue;
                }
                if (o != (Number(this.chargeSelectArr[i]) + 1 + '')) {
                    bSuccess = false;
                    break;
                }
            }
        }
        
        let awardGroup = bSuccess ? this.csvInfo.success : this.csvInfo.lose;
        let retArr = utilsModel.splitLineFeed(awardGroup);
        this.showResultUI(bSuccess, retArr);
    }

    // update (dt) {}
}
